import { defineMessages } from "react-intl";

const messages = defineMessages({
  emailFieldArchivedDescriptionForNonOwner: {
    id: "email.creation.recipientsAddModal.emailFieldArchivedDescriptionForNonOwner",
    defaultMessage:
      "Email field has been archived for all companies. Ask an owner to unarchive it to send emails.",
    description: "Add Recipients email archived description",
  },
  emailFieldArchivedDescriptionForOwner: {
    id: "email.creation.recipientsAddModal.emailFieldArchivedDescriptionForOwner",
    defaultMessage:
      "Email field is archived for all people. Unarchive it to allow your organization to email people records.",
    description: "Add Recipients email archived description",
  },
  emailFieldNotAvailableTitle: {
    id: "email.creation.recipientsAddModal.emailFieldNotAvailableTitle",
    defaultMessage: "Email not available",
    description: "Add Recipients email not available title",
  },
  emailNotAvailableTitle: {
    id: "email.creation.recipientsAddModal.emailNotAvailableTitle",
    defaultMessage: "Email not available",
    description: "Add Recipients email not available title",
  },
  goToArchiveText: {
    id: "email.creation.recipientsAddModal.goToArchiveText",
    defaultMessage: "Go to archive",
    description: "Add Recipients go to archive in email creation modal",
  },
  infoMessage: {
    id: "email.creation.recipientsAddModal.infoMessage",
    defaultMessage: "Only records with emails can be added",
    description: "Add Recipients information in email creation modal",
  },
  listTitle: {
    id: "email.creation.recipientsAddModal.listTitle",
    defaultMessage: "Record With Email ({count}/{total})",
    description: "Add Recipients list title in email creation modal",
  },
  selectCompaniesTitle: {
    id: "email.creation.recipientsAddModal.selectCompaniesTitle",
    defaultMessage: "Select Companies",
    description: "Add Recipients select companies title",
  },
  selectPeopleTitle: {
    id: "email.creation.recipientsAddModal.selectPeopleTitle",
    defaultMessage: "Select People",
    description: "Add Recipients select people title",
  },
  selectText: {
    id: "email.creation.recipientsAddModal.select",
    defaultMessage: "Select",
    description: "Add Recipients select text in email creation modal",
  },
});

export default messages;
